export var TransactionType;
(function (TransactionType) {
    TransactionType["USAGE"] = "usage";
    TransactionType["USAGE_CORRECTION"] = "usage_correction";
    TransactionType["SUBSCRIPTION"] = "subscription";
    TransactionType["REFILL"] = "refill";
    TransactionType["BONUS"] = "bonus";
})(TransactionType || (TransactionType = {}));
export var BonusSource;
(function (BonusSource) {
    BonusSource["MANUAL"] = "MANUAL";
    BonusSource["REGISTRATION"] = "REGISTRATION";
    BonusSource["SUBSCRIPTION"] = "SUBSCRIPTION";
})(BonusSource || (BonusSource = {}));
export var TransactionStatuses;
(function (TransactionStatuses) {
    TransactionStatuses["SUCCESS"] = "success";
    TransactionStatuses["FAILED"] = "failed";
    TransactionStatuses["PENDING"] = "pending";
})(TransactionStatuses || (TransactionStatuses = {}));
//# sourceMappingURL=constants.js.map